import { EntityWidget } from "./EntityWidget"; 
import { TechnicalElementEntityController } from "../TechnicalElementEntityController";
import { SceneConstants, TechnicalElement } from "@rhinov/savane-js";

export class TechnicalElementEntityWidget extends EntityWidget{

    declare entity: TechnicalElement;
    declare controller: TechnicalElementEntityController;

    handleImageListEvent = (event: MouseEvent) => {
        var elem =  event.currentTarget as HTMLButtonElement & { func?: string, param?: any };
        if (event.ctrlKey) {
            this.controller.openAssetDetail(elem.param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
           
            var index = 0;
            this.controller.modelList.forEach((modele: any) => {
                let element = document.getElementById(`TechnicalElementModel-${index}`);
                if (element) {
                    element.classList.remove('active');
                }
                index++;
            })
            elem.classList.add('active');
            (this.controller as any)[elem.func!](elem.param);
            let preview = document.getElementById('previewTechElem')
            if (preview && preview.getElementsByTagName("img")[0]) {
                preview.getElementsByTagName("img")[0].src = this.controller.itemPreview ?? '';
            }
        }
    }

    constructor(entity: TechnicalElement, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new TechnicalElementEntityController(entity,panel, deliverable, openAssetDetailCallback);
        switch (this.entity.objectId) {
            case SceneConstants.TechnicalElementType.pole:
                this.propertiesTab = ['dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.serviceShaft:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.fireplace:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.radiator:
            case SceneConstants.TechnicalElementType.beam:
                this.propertiesTab = ['dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.stove:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.waterSource:
                this.propertiesTab = ['buttonToggle', 'buttonToggle'];
                break;
            case SceneConstants.TechnicalElementType.socketTV:
            case SceneConstants.TechnicalElementType.socketSixteen:
            case SceneConstants.TechnicalElementType.socketThirtyTwo:
                this.propertiesTab = [ 'plusLess', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.switchBoard:
            case SceneConstants.TechnicalElementType.wardRobe:
            case SceneConstants.TechnicalElementType.rosette:
            case SceneConstants.TechnicalElementType.boiler:
            case SceneConstants.TechnicalElementType.airConditioner:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.spotLight:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'dropDown', 'colorSelector', 'dropDown', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.frame:
                this.propertiesTab = ['dropDown', 'dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess'];
                break;
            case SceneConstants.TechnicalElementType.wallDecoration:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'previewTechnicalElement', 'selectTechnicalElementModel'];
                break;
            case SceneConstants.TechnicalElementType.guardrail:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'previewWall', 'selectWallModel'];
        }
        this.controller.propertiesTab = this.propertiesTab;
    }

    handleElementList(): string {
        var html = "";
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            html += `
                <img id="TechnicalElementModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                    title="${modele.name}"
                    src="${this.controller.getTechnicalElementPreviewUrl(modele)}"
                    class="${this.controller.isTechnicalElementModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectTechnicalElementModel(property: any): string {
        return `
            <!--Select model for technical elements-->
            <div class="property-item padding tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div style="margin-bottom:10px;padding:0;width:382px;max-height:600px;overflow-y:auto">
                    ${this.handleElementList()}
                </div>
            </div>
        `;
    }

    setselectTechnicalElementModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`)  as HTMLButtonElement & { func?: string, param?: any };
            if (element) {
                element.func = "updateTechnicalElementModeleType"
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectTechnicalElementModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }
    
    previewTechnicalElement(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewTechElem" class="property-item padding tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img style="width:180px;height:180px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewTechnicalElementListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    removepreviewTechnicalElementListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails)
        }
    }


    handleWallModels(): string {
        var html = "";
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            html += `
                <img id="TechnicalElementModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                    title="${modele.name}"
                    src="${this.controller.getWallPreviewUrl(modele)}"
                    class="${this.controller.isWallModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectWallModel(property: any): string {
        return `
            <!--Select model for special walls-->
            <div id="wallContainer" class="padding wallModel tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div style="margin-bottom:10px;padding:0;width:382px;max-height:600px;overflow-y:auto">
                    ${this.handleWallModels()}
                </div>
            </div>
        `;
    }

    setselectWallModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`)  as HTMLButtonElement & { func?: string, param?: any };
            if (element) {
                element.func = "updateWallModeleType"
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectWallModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    previewWall(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewTechElem" class="property-item padding wallPreview tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img style="width:180px;height:180px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewWallListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    removepreviewWallListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails)
        }
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }
        html += super.propertyEnd();
        return html;
    }
}